import React, { useEffect } from 'react';
import { useLazyFetchEnquiryFormQuery } from './EnquiryForm.service';
import { EnquiryForm } from './EnquiryForm';

export const ContactUsBlock = () => {
  const contactUsBlock = document.getElementById('ContactUsBlock');
  const data = JSON.parse(contactUsBlock?.dataset.data);
  const enqType = data.enquiryType;
  const pageId = data.pageId;
  const categoryId = data.CategoryId;
  const dropdownToDisable = data.dropdownToDisable;
  const isContactUsBlock = data.isContactUsBlock;
  const parentPageID = data.currentPageId;

  const [fetchEnquiryForm, { data: formData }] = useLazyFetchEnquiryFormQuery();

  useEffect(() => {
    fetchEnquiryForm({ enquiryType: enqType, pageId, categoryId });
  }, []);

  return (
    <EnquiryForm
      dropdownToDisable={dropdownToDisable}
      formData={formData}
      type={enqType}
      pageId={pageId}
      isContactUsBlock={isContactUsBlock}
      parentPageID={parentPageID}
    />
  );
};
